<template>
    <div class='content'>
         <el-card class="box-card" v-loading='loading2' :element-loading-text="loadingTxt">
            <el-row>
              <el-col :span="12">
                <el-upload
                  class="upload-demo"
                  name='upload_excel'
                  :action="uploadUrl"
                  :headers='fileHeader'
                  :on-exceed='handleExceed'
                  :on-success='handleUploadOK'
                  :before-upload="handleBeforeUP"
                  :file-list='fileList'
                  :limit="1"
                  ref="myupload"
                  >
                  <el-button size="small" type="primary">选择文件</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx/csv文件</div>
                </el-upload>
              </el-col>
            </el-row>
        </el-card>

        <el-divider>上传历史</el-divider>

        <div class="search_unit">
      <div style='display:inline-block;'>
       <el-input placeholder="请输入商业公司名称" v-model="keywords" class="input-with-select" @change='getList()'>
        <el-select v-model="type" slot="prepend" placeholder="筛选条件" @change="getList()">
            <el-option v-for="item in typelist" :key="item.val" :label="item.name"  :value="item.val"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
       </el-input>
      </div> 
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="uploaddate"
        label="上传日期"
        >
      </el-table-column>
      <el-table-column
        prop="filename"
        label="文件名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="drugsalecorp"
        label="商业公司">
      </el-table-column>
      <el-table-column
        prop="total"
        label="记录条数">
      </el-table-column>
      <el-table-column
        prop="memo"
        label="备注说明">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope"> 
          <el-tag type="success">{{scope.row.statusval}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
          <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)" size="small" v-if="scope.row.type==1 && scope.row.hasdeleted==0">批量删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
        
    </div>
  </template>

  <script>
  export default {
      data() {
        return {
          fileHeader:{}, 
          fileList:[],
          
          loading:false, 
          loading2:false,
          loadingTxt:'上传中...',
          processing:false,
          uploadUrl:process.env.VUE_APP_API+"/import/handleExcel",
         
          tableData:[],
          keywords:'',
          type:2,
          pageinfo:{
            total:0,
            pagesize:10,
            pageindex:1
          },
          typelist:[{name:"今天",val:1},{name:"本月",val:2},{name:"上个月",val:3},{name:"更早",val:4}]
        }
      },
      created(){
         this.getList(); 
         this.fileHeader={"htkstoken":this.$store.state.user.token}
      },
      methods:{
          getList(){
            this.loading=true
            this.$post("/import/getUploadHistory",{pageinfo:this.pageinfo,keywords:this.keywords,type:this.type}).then((data)=>{
              this.loading=false 
              if(data.result.success){
                  this.tableData=data.result.info.contentlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
            })
          },
          handleExceed(){
             this.$message("超出最大上传数量，请删除后重新上传")
          },
          handleBeforeUP(){
              this.loading2=true
          },
          handleUploadOK(data){
              this.loading2=false
              if(data.result.success){
                  this.$message({type:"success",message:'上传文件成功'})
                  this.fileList=[]
                  this.getList()
              }else{
                  this.$message({type:"error",message:data.result.info})
                  this.fileList=[]
              }
          },
          handleDelete(id){
          this.$confirm('此操作将删除所有此次上传的数据源记录,与之相关的奖励会发生变化, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doDelete(id)
          }).catch(() => {
                      
          }); 
        },
        doDelete(id){
          if(this.processing){
            this.$message.error("请等待处理完成");return false
          }
          this.processing=true
          this.$post("/import/delBatch",{id:id}).then((data)=>{
                this.processing=false
                if(data.result.success){
                    this.$message({message:data.result.info,type:'success'})
                    setTimeout(()=>{this.getList()},500)
                }else{
                    this.$message.error(data.result.info)
                }
          })
        }
      }
    }
  </script>

<style scoped>
 .form{
    margin-top:0.5rem;
 }
 .surebtn{
    margin-top:0.5rem;
 }
   .el-tabs--left, .el-tabs--right{overflow: auto;}

</style>